//state
import axios from "axios";

export var stereotypeState = {
  stereotypes: [],
  stereotype: {},
  status_stereotype: "",
  stereotypesbyPartner:[],
};

//getters
export var stereotypeGetters = {
  //funciones para optener informacion del state
  getStereotypes: state => state.stereotypes,
  getStereotypesbyPartner: state => state.stereotypesbyPartner
};
const user_context = JSON.parse(localStorage.getItem('user_context'));
const uid = localStorage.getItem("uid");
const pass = localStorage.getItem("pass");

//actions
export var stereotypeActions = {
  async getStereotypesbyPartner({ commit }) {//,partner_id
    //console.log("comit :::: ", commit);
    commit("stereotype_request");
    var req_data={
          "jsonrpc": "2.0",
          "method": "call",
          "params": {
              service: 'object',
              method: 'execute',
              args: [axios.defaults.db, uid, pass, 'apache.adset.targeting', 'search_read', [], [],0,0,""]
            }
          }

    await this._vm.$http
      .post("jsonrpc", req_data)
      .then(res => {
        var stereotypes = [];//res.data;
        if(res.data.result.length > 0){
          stereotypes = res.data.result
        }
        //console.log("response stereotypes:::::",res.data);
        commit("stereotypesbyPartner_success", stereotypes);
        return res;
      })
      .catch(err => {
        commit("stereotype_error");
        return err;
      });
  },
  async getStereotypes({ commit }) {
    ////console.log("comit :::: ", commit);
    commit("stereotype_request");
    var req_data={
            "jsonrpc": "2.0",
            "method": "call",
            "params": {
                service: 'object',
                method: 'execute',
                args: [axios.defaults.db, uid, pass, 'apache.adset.targeting', 'search_read', [], ["id","name", "wireless_carrier", "gender", "age_min", "age_max", "recommended_locations","os_ids","device_platforms_ids", "publisher_platforms_ids","position_ids","custom_audience_ids","exclude_audience_ids","exclude_states_ids"],
                    0,
                    0,
                    ""
                ]
              }
            }

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(res => {
        var stereotypes=[];
        if(res.data.result.length > 0) 
          stereotypes = res.data.result;
        ////console.log("response stereotypes:::::",res.data);
        commit("stereotype_success", stereotypes);
        return res;
      })
      .catch(err => {
        commit("stereotype_error");
        return err;
      });
  },
  async newStereotype({ commit, state }, stereotype) {
    commit("stereotype_request");
    var {
      gender,
      age_max,
      age_min,
      recommended_locations,
      name,
      // custom_audience_ids,
      // exclude_audience_ids,
      os_ids,
      device_platforms_ids,
      publisher_platforms_ids,
      position_ids,
      genderSelected,
      conectionType,
      conectionTypeSelected,
      positon_selected,
      platform,
      device,
      os_selected,
      // audienciasSelectedExclude,
      // audienciasSelectedInclude
    } = stereotype;
    var formData = new FormData();
    var newStereotype = {}
    // "custom_audience_ids": [${custom_audience_ids}],
    //     "exclude_audience_ids": [${exclude_audience_ids}],
        
    if (!recommended_locations){
       newStereotype ={
        'name':name,
        'age_max':age_max,
        'age_min': age_min,
        'gender':genderSelected.id,
        'recommended_locations': recommended_locations,

        'gender': gender,
        'wireless_carrier':conectionType,

        "os_ids": [[6, false, os_ids]],
        "device_platforms_ids": [[6, false, device_platforms_ids]],
        "publisher_platforms_ids": [[6, false,publisher_platforms_ids]],
        "position_ids": [[6, false, position_ids]],
        };
        // 'relational_fields': [

        //                       ('os_ids', 'apache.adset.useros'),
        //                       ('publisher_platforms_ids', 'apache.adset.publisherplatform'),
        //                       ('position_ids', 'apache.adset.position'),
        //                       ('device_platforms_ids', 'apache.adset.deviceplatform'),
                             
        //                     ]
        // ('custom_audience_ids', 'apache.adset.targeting.audience'),
        //                       ('exclude_audience_ids', 'apache.adset.targeting.audience'),
    }else{
       newStereotype = {
        'name':name,
        'age_max':age_max,
        'age_min': age_min,
        'gender':genderSelected.id,
        'wireless_carrier':conectionType,
        'recommended_locations': recommended_locations,
        'gender': gender,
        };
        // "custom_audience_ids": [${custom_audience_ids}],
        // "exclude_audience_ids": [${exclude_audience_ids}],
    }
    // 'relational_fields': [('custom_audience_ids', 'apache.adset.targeting.audience'),
    //                           ('exclude_audience_ids', 'apache.adset.targeting.audience'),
    //                         ]

   
    // formData.append("data", newStereotype);
 
    var req_data ={
             "jsonrpc": "2.0",
             "method": "call",
             "params": {
                service: 'object',
                method: 'execute',
                args: [axios.defaults.db, uid, pass, 'apache.adset.targeting', 'create', [newStereotype] ]
             }
         }


    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(res => {

        if (res.data.result!="") {
          stereotype.id = res.data.id;
          stereotype.os_ids = os_selected;
          stereotype.device_platforms_ids = device;
          stereotype.publisher_platforms_ids = platform;
          stereotype.position_ids = positon_selected;
          stereotype.gender = genderSelected.id;
          stereotype.wireless_carrier = conectionTypeSelected;
          stereotype.exclude_audience_ids = audienciasSelectedExclude;
          stereotype.custom_audience_ids = audienciasSelectedInclude;
          var stereotypes = state.stereotypes;
          stereotypes.push(stereotype);
          commit("stereotype_success", stereotypes);
          return stereotypes;
        } else {
          commit("stereotype_error");
        }
      })
      .catch(err => {
        commit("stereotype_error");
        return err;
      });
  },
  async newStereotype12({ commit, state }, stereotype) {
    commit("stereotype_request");
    var {
      gender,
      age_max,
      age_min,
      recommended_locations,
      name,
      // custom_audience_ids,
      // exclude_audience_ids,
      os_ids,
      device_platforms_ids,
      publisher_platforms_ids,
      position_ids,
      genderSelected,
      conectionType,
      conectionTypeSelected,
      positon_selected,
      platform,
      device,
      os_selected,
      exclude_states_ids
      // audienciasSelectedExclude,
      // audienciasSelectedInclude
    } = stereotype;
    var formData = new FormData();
    var newStereotype = {}
    // "custom_audience_ids": [${custom_audience_ids}],
    //     "exclude_audience_ids": [${exclude_audience_ids}],
        
    if (!recommended_locations){
       newStereotype = `{
        'name':'${name}',
        'age_max':'${age_max}',
        'age_min': '${age_min}',
        'gender':'${genderSelected.id}',
        'recommended_locations': ${(recommended_locations)?'True':'False'},

        'gender': '${gender}',
        'wireless_carrier':'${conectionType}',
        "os_ids": [${os_ids}],
        "device_platforms_ids": [${device_platforms_ids}],
        "publisher_platforms_ids": [${publisher_platforms_ids}],
        "position_ids": [${position_ids}],
        'relational_fields': [

                              ('os_ids', 'apache.adset.useros'),
                              ('publisher_platforms_ids', 'apache.adset.publisherplatform'),
                              ('position_ids', 'apache.adset.position'),
                              ('device_platforms_ids', 'apache.adset.deviceplatform'),
                             
                            ]
        }`;
        // ('custom_audience_ids', 'apache.adset.targeting.audience'),
        //                       ('exclude_audience_ids', 'apache.adset.targeting.audience'),
    }else{
       newStereotype = `{
        'name':'${name}',
        'age_max':'${age_max}',
        'age_min': '${age_min}',
        'gender':'${genderSelected.id}',
        'wireless_carrier':'${conectionType}',
        'recommended_locations': ${(recommended_locations)?'True':'False'},
        'gender': '${gender}',
        }`;
        // "custom_audience_ids": [${custom_audience_ids}],
        // "exclude_audience_ids": [${exclude_audience_ids}],
    }
    // 'relational_fields': [('custom_audience_ids', 'apache.adset.targeting.audience'),
    //                           ('exclude_audience_ids', 'apache.adset.targeting.audience'),
    //                         ]

   
    formData.append("data", newStereotype);
    await this._vm.$http
      .post("/apache/rest_api/apache.adset.targeting", formData, {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        if (res.status == 201) {
          stereotype.id = res.data.id;
          stereotype.os_ids = os_selected;
          stereotype.device_platforms_ids = device;
          stereotype.publisher_platforms_ids = platform;
          stereotype.position_ids = positon_selected;
          stereotype.gender = genderSelected.id;
          stereotype.wireless_carrier = conectionTypeSelected;
          // stereotype.exclude_audience_ids = audienciasSelectedExclude;
          // stereotype.custom_audience_ids = audienciasSelectedInclude;
          var stereotypes = state.stereotypes;
          stereotypes.push(stereotype);
          commit("stereotype_success", stereotypes);
          return stereotypes;
        } else {
          commit("stereotype_error");
        }
      })
      .catch(err => {
        commit("stereotype_error");
        return err;
      });
  },
  async editStereotype({ commit, state }, stereotype) {
    commit("stereotype_request");
    var {
      id,
      gender,
      age_max,
      age_min,
      recommended_locations,
      name,
      // custom_audience_ids,
      // exclude_audience_ids,
      os_ids,
      device_platforms_ids,
      publisher_platforms_ids,
      position_ids,
      genderSelected,
      conectionType,
      conectionTypeSelected,
      positon_selected,
      platform,
      device,
      os_selected,
      exclude_states_ids
      // audienciasSelectedExclude,
      // audienciasSelectedInclude
    } = stereotype;
    var formData = new FormData();
    var newStereotype = {}
    // "custom_audience_ids": [${custom_audience_ids}],
        // "exclude_audience_ids": [${exclude_audience_ids}],
        // ('custom_audience_ids', 'apache.adset.targeting.audience'),
        //                       ('exclude_audience_ids', 'apache.adset.targeting.audience'),

    if (!recommended_locations){
       var recommended_locations1 = recommended_locations === true ? "True" : "False";

       newStereotype = {
        'name':name,
        'age_max':age_max,
        'age_min': age_min,
        // 'gender':genderSelected.id,
        'recommended_locations': recommended_locations ,//`${(recommended_locations)?'True':'False'}`,
        'gender': gender,
        'wireless_carrier': conectionType,

        "os_ids": [[6, false, os_ids]],
        "device_platforms_ids": [[6, false, device_platforms_ids]],
        "publisher_platforms_ids": [[6, false,publisher_platforms_ids]],
        "position_ids": [[6, false, position_ids]],
        "exclude_states_ids": [[6, false, exclude_states_ids]],
        };
        // 'relational_fields': [

        //                       ('os_ids', 'apache.adset.useros'),
        //                       ('publisher_platforms_ids', 'apache.adset.publisherplatform'),
        //                       ('position_ids', 'apache.adset.position'),
        //                       ('device_platforms_ids', 'apache.adset.deviceplatform'),                             
        //                     ]
    }else{
      var recommended_locations1 = recommended_locations ;
       newStereotype = {
        'name':name,
        'age_max':age_max,
        'age_min': age_min,
        'gender':genderSelected.id,
        'recommended_locations': recommended_locations,
        'gender': gender,
        'wireless_carrier':conectionType,

        };
    }
    //console.log("newStereotype", newStereotype);
    //"custom_audience_ids": [${custom_audience_ids}],
        // "exclude_audience_ids": [${exclude_audience_ids}],
        // 'relational_fields': [('custom_audience_ids', 'apache.adset.targeting.audience'),
        //                       ('exclude_audience_ids', 'apache.adset.targeting.audience'),
        //                     ]
    // formData.append("data", newStereotype);
    var req_data={
           "jsonrpc": "2.0",
           "method": "call",
           "params": {
              service: 'object',
              method: 'execute',
              args: [axios.defaults.db, uid, pass, 'apache.adset.targeting', 'write', [id], newStereotype ]
           }
       }

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then(res => {
        //console.log("res.data.result :::: ", res.data.result);
        if (res.data.result != "") {
          stereotype.os_ids = os_selected;
          stereotype.device_platforms_ids = device;
          stereotype.publisher_platforms_ids = platform;
          stereotype.position_ids = positon_selected;
          stereotype.gender = genderSelected.id;
          stereotype.wireless_carrier = conectionTypeSelected;
          // stereotype.exclude_audience_ids = audienciasSelectedExclude;
          // stereotype.custom_audience_ids = audienciasSelectedInclude;
          var stereotypes = state.stereotypes;
          var index;
          for (var i = 0; i < stereotypes.length; i++) {
            if (stereotypes[i].id == id) {
              index = i;
              stereotypes[i] = stereotype;
              break;
            }
          }
          stereotypes.splice(index, 1);
          stereotypes.splice(index, 0, stereotype);
          commit("stereotype_success", stereotypes);
          return stereotypes;
        } else {
          commit("stereotype_error");
        }
      })
      .catch(err => {
        commit("stereotype_error");
        return err;
      });
  },
  async editStereotype12({ commit, state }, stereotype) {
    commit("stereotype_request");
    var {
      id,
      gender,
      age_max,
      age_min,
      recommended_locations,
      name,
      // custom_audience_ids,
      // exclude_audience_ids,
      os_ids,
      device_platforms_ids,
      publisher_platforms_ids,
      position_ids,
      genderSelected,
      conectionType,
      conectionTypeSelected,
      positon_selected,
      platform,
      device,
      os_selected,
      // audienciasSelectedExclude,
      // audienciasSelectedInclude
    } = stereotype;
    var formData = new FormData();
    var newStereotype = {}
    // "custom_audience_ids": [${custom_audience_ids}],
        // "exclude_audience_ids": [${exclude_audience_ids}],
        // ('custom_audience_ids', 'apache.adset.targeting.audience'),
        //                       ('exclude_audience_ids', 'apache.adset.targeting.audience'),

    if (!recommended_locations){
       var recommended_locations1 = recommended_locations === true ? "True" : "False";

       newStereotype = `{
        'name':'${name}',
        'age_max':'${age_max}',
        'age_min': '${age_min}',
        'gender':'${genderSelected.id}',
        'recommended_locations': ${(recommended_locations)?'True':'False'},
        'gender': '${gender}',
        'wireless_carrier': '${conectionType}',

        "os_ids": [${os_ids}],
        "device_platforms_ids": [${device_platforms_ids}],
        "publisher_platforms_ids": [${publisher_platforms_ids}],
        "position_ids": [${position_ids}],
        'relational_fields': [

                              ('os_ids', 'apache.adset.useros'),
                              ('publisher_platforms_ids', 'apache.adset.publisherplatform'),
                              ('position_ids', 'apache.adset.position'),
                              ('device_platforms_ids', 'apache.adset.deviceplatform'),                             
                            ]
        }`;
    }else{
      var recommended_locations1 = recommended_locations === true ? "True" : "False";
       newStereotype = `{
        'name':'${name}',
        'age_max':'${age_max}',
        'age_min': '${age_min}',
        'gender':'${genderSelected.id}',
        'recommended_locations': ${(recommended_locations)?'True':'False'},
        'gender': '${gender}',
        'wireless_carrier':'${conectionType}',

        }`;
    }
    //console.log("newStereotype", newStereotype);
    //"custom_audience_ids": [${custom_audience_ids}],
        // "exclude_audience_ids": [${exclude_audience_ids}],
        // 'relational_fields': [('custom_audience_ids', 'apache.adset.targeting.audience'),
        //                       ('exclude_audience_ids', 'apache.adset.targeting.audience'),
        //                     ]
    formData.append("data", newStereotype);
    await this._vm.$http
      .put("/apache/rest_api/apache.adset.targeting", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          stereotype.os_ids = os_selected;
          stereotype.device_platforms_ids = device;
          stereotype.publisher_platforms_ids = platform;
          stereotype.position_ids = positon_selected;
          stereotype.gender = genderSelected.id;
          stereotype.wireless_carrier = conectionTypeSelected;
          // stereotype.exclude_audience_ids = audienciasSelectedExclude;
          // stereotype.custom_audience_ids = audienciasSelectedInclude;
          var stereotypes = state.stereotypes;
          var index;
          for (var i = 0; i < stereotypes.length; i++) {
            if (stereotypes[i].id == id) {
              index = i;
              stereotypes[i] = stereotype;
              break;
            }
          }
          stereotypes.splice(index, 1);
          stereotypes.splice(index, 0, stereotype);
          commit("stereotype_success", stereotypes);
          return stereotypes;
        } else {
          commit("stereotype_error");
        }
      })
      .catch(err => {
        commit("stereotype_error");
        return err;
      });
  },
  async deleteStereotypeAction({ commit, state }, id) {
    commit("stereotype_request");
    try {
      var req_data = {
             "jsonrpc": "2.0",
             "method": "call",
             "params": {
                service: 'object',
                method: 'execute',
                args: [axios.defaults.db, uid, pass, 'apache.adset.targeting', 'unlink', [id]]
             }
         }

      await this._vm.$http
        .post("/jsonrpc", req_data)
        .then(res => {
          if (res.status == 200) {
            var index;
            var stereotypes = state.stereotypes;
            for (var i = 0; i < stereotypes.length; i++) {
              if (stereotypes[i].id == id) {
                index = i;
                break;
              }
            }
            stereotypes.splice(index, 1);
            commit("stereotype_success", stereotypes);

            return stereotypes;
          } else {
            commit("stereotype_error");
          }
        })
        .catch(err => {
          commit("stereotype_error");
          return err;
        });
    } catch (error) {
      //console.log(error);
    }
  },
  async deleteStereotypeAction12({ commit, state }, id) {
    commit("stereotype_request");
    try {
      await this._vm.$http
        .delete(`/apache/rest_api/apache.adset.targeting/${id}`, {
          headers: {
            "X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          if (res.status == 210) {
            var index;
            var stereotypes = state.stereotypes;
            for (var i = 0; i < stereotypes.length; i++) {
              if (stereotypes[i].id == id) {
                index = i;
                break;
              }
            }
            stereotypes.splice(index, 1);
            commit("stereotype_success", stereotypes);

            return stereotypes;
          } else {
            commit("stereotype_error");
          }
        })
        .catch(err => {
          commit("stereotype_error");
          return err;
        });
    } catch (error) {
      //console.log(error);
    }
  },
  async deleteStereotypeUtility({ commit, state }, id) {
    commit("stereotype_request");
    var index;
    var stereotypes = state.stereotypes;
    for (var i = 0; i < stereotypes.length; i++) {
      if (stereotypes[i].id == id) {
        index = i;
        break;
      }
    }
    stereotypes.splice(index, 1);
    commit("stereotype_success", stereotypes);

    return stereotypes;
  }
};

//mutations

export var stereotypeMutations = {
  stereotype_request(state) {
    state.status_stereotype = "loading";
  },
  stereotype_success(state, payload) {
    state.status_stereotype = "success";
    state.stereotypes = payload;
  },
  stereotypesbyPartner_success(state, payload) {
    state.status_stereotype = "success";
    state.stereotypesbyPartner = payload;
  },
  stereotype_error(state) {
    state.status_stereotype = "error";
  }
};
